<template>
  <b-tabs class="m-sm-4 my-4" nav-wrapper-class="card-tabs">
    <b-card id="adFormats" class="tabs-card p-sm-4">
      <h5 v-if="circledNum" class="circled-number">{{ circledNum }}</h5>
      <h5 class="card-title pt-2">Ad Formats</h5>
      <b-card v-if="zone.ad_formats.length < 2" no-body bg-variant="light-primary" border-variant="primary" class="text-center py-3 my-4">
        Enabling multiple formats may increase competition producing higher per-zone revenues
      </b-card>
      <b-tab :title-link-class="{ update_trigger_hack: true }">
        <template slot="title">
          Banner
          <span @click="toggleFormat('BANNER')">
            <toggle-button
              :value="zone.ad_formats.includes('BANNER')"
              :sync="true"
              :width=35
              :height=19
              class="my-auto ml-2"
              color="#2bd879">
            </toggle-button>
          </span>
        </template>
        <div :class="{'ad-format-deactivated': !zone.ad_formats.includes('BANNER')}">
          <banner-options v-model="zone.banner" :medium="medium"></banner-options>
        </div>
      </b-tab>
      <b-tab :title-link-class="{ update_trigger_hack: true }">
        <template slot="title">
          Video
          <span @click="toggleFormat('VIDEO')">
            <toggle-button
              :value="zone.ad_formats.includes('VIDEO')"
              :sync="true"
              :width=35
              :height=19
              class="my-auto ml-2"
              color="#2bd879">
            </toggle-button>
          </span>
        </template>
        <div :class="{'ad-format-deactivated': !zone.ad_formats.includes('VIDEO')}">
          <video-options v-model="zone.video" :medium="medium">
          </video-options>
        </div>
      </b-tab>
      <b-tab disabled title="Native Ads (coming soon)">
      </b-tab>
    </b-card>
  </b-tabs>

</template>

<style>
.ad-format-deactivated {
  opacity: 0.5;
}
</style>

<script type="text/javascript">
import BannerOptions from '@/publisher/pages/Zone/ZoneSettings/AdFormats/BannerOptions'
import VideoOptions from '@/publisher/pages/Zone/ZoneSettings/AdFormats/VideoOptions'
import {PublisherApi} from '@/publisher/api'

export default{
  props: {
    circledNum: { required: false, type: String },
      value: { required: true, type: Object } /* zone obj */
  },
    mounted() {
      PublisherApi.mediumDetails(this.value.company_id, this.value.med_id).then((medium) => {
          this.medium = medium
      })
    },
    data() {
      return {
          medium: {}
      }
    },
    methods: {
      toggleFormat(format) {
          let af = this.zone.ad_formats
          if(af.indexOf(format) === -1) {
              af.push(format)
          } else {
              af.splice(af.indexOf(format), 1)
          }
      }
    },
    computed: {
      zone () {
          return this.value
      }
    },
  components: {
    BannerOptions,
    VideoOptions
  }
}

</script>



// WEBPACK FOOTER //
// src/publisher/pages/Zone/ZoneSettings/AdFormat.vue